<template>
  <div>
    <!-- <router-view /> -->
    <SideWrp />
  </div>
</template>

<script>
import SideWrp from './sideWrap/index.vue'
export default {
  components: { SideWrp },
  mounted() {
    // console.log('layout mounted')
  }
}
</script>
